// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Utils__ReactLoaderController from "./utils/react_loader_controller"
application.register("utils--react-loader", Utils__ReactLoaderController)

import Utils__AutosaveController from "./utils/autosave_controller"
application.register("utils--autosave", Utils__AutosaveController)

import Utils__RequestableSubmitController from "./utils/requestable_submit_controller"
application.register("utils--requestable-submit", Utils__RequestableSubmitController)
